var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D6D0F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EEECFF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3332 28.9163V22.2696C35.3332 22.1972 35.319 22.1256 35.2913 22.0587C35.2636 21.9919 35.223 21.9311 35.1718 21.88L32.2862 18.9943C32.1831 18.8912 32.0433 18.8331 31.8975 18.833H21.2165C21.0706 18.833 20.9307 18.891 20.8276 18.9941C20.7245 19.0972 20.6665 19.2371 20.6665 19.383V36.6163C20.6665 36.7622 20.7245 36.9021 20.8276 37.0053C20.9307 37.1084 21.0706 37.1663 21.2165 37.1663H29.8332",
    stroke: "#512C9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6665 18.833V21.9497C31.6665 22.0955 31.7244 22.2354 31.8276 22.3386C31.9307 22.4417 32.0706 22.4997 32.2165 22.4997H35.3332M31.6665 34.4163H37.1665M37.1665 34.4163L34.4165 31.6663M37.1665 34.4163L34.4165 37.1663",
    stroke: "#512C9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/Submitted.9e457dee0d6453141cda646c43faf4ec.svg";
export { ForwardRef as ReactComponent };